import React, { createContext, useContext } from "react";
import { useAuthLogic } from "../hooks/useAuth";

type AuthContextType = ReturnType<typeof useAuthLogic>;

const AuthContext = createContext<AuthContextType | null>(null);

type ChildrenType = {
  children: React.ReactNode;
};

export const AuthProvider = ({ children }: ChildrenType) => {
  const authObj = useAuthLogic();

  return (
    <AuthContext.Provider value={authObj}>
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
